import loginService from './login.js';

export default {
  loginService
}
